module.exports = __webpack_public_path__ + "img/testing.895f8912.svg";